<template>
  <div>
    <el-dialog
      v-if="info"
      title="编辑认证信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="60%"
      class="editDialog"
      center
    >
      <div class="editDialog-cnt">
        <el-form
          class="demo-addForm"
          label-width="200px"
          ref="refCityForm"
          :model="addForm"
          :rules="cityRules"
        >
          <el-form-item label="主体性质" prop="certification_type">
            <el-radio-group
              v-model="addForm.certification_type"
               
            >
              <el-radio :label="10">个人</el-radio>
              <el-radio :label="20">个体工商户</el-radio>
              <el-radio :label="30">企业</el-radio>
            </el-radio-group>
          </el-form-item>
         
          <el-form-item label="营业执照" prop="license_img">
            <el-upload
              :action="httpurl"
              :on-preview="onHandlePictureCardPreview"
              :class="{ hide: license_img.length || !license_img }"
              :file-list="license_img"
              :headers="{ token: token }"
              list-type="picture-card"
              :on-success="onsuccess"
              :before-remove="() => onHandleDeleteFile('license_img')"
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="统一社会信息码" prop="uscc">
            <div>
              <el-input
                v-model="addForm.uscc"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="持卡人身份证国徽页图片" prop="idcard_a">
            <el-upload
              action="#"
              v-loading="uploadLoading"
              :on-preview="onHandlePictureCardPreview"
              :class="{ hide: idcard_a.length || !idcard_a }"
              :file-list="idcard_a"
              list-type="picture-card"
              :http-request="(data) => onHandleUploadFile(data, 'idcard_a')"
              :before-remove="() => onHandleDeleteFile('idcard_a')"
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="持卡人身份证人像页图片" prop="idcard_b">
            <el-upload
              action="#"
              v-loading="uploadLoading"
              :on-preview="onHandlePictureCardPreview"
              :class="{ hide: idcard_b.length || !idcard_b }"
              :file-list="idcard_b"
              list-type="picture-card"
              :http-request="(data) => onHandleUploadFile(data, 'idcard_b')"
              :before-remove="() => onHandleDeleteFile('idcard_b')"
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="企业联系电话"
            prop="company_mobile"
            v-if="addForm.certification_type==30"
          >
            <div>
              <el-input
                v-model="addForm.company_mobile"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label="
              addForm.certification_type != 10 ? '法人姓名' : '持卡人姓名'
            "
            prop="idcard_name"
          >
            <div>
              <el-input
                v-model="addForm.idcard_name"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item
            :label="
              addForm.certification_type != 10
                ? '法人身份证号'
                : '持卡人身份证号'
            "
            prop="idcard_code"
          >
            <div>
              <el-input
                v-model="addForm.idcard_code"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            :label="
              addForm.certification_type != 10 ? '法人手机号码' : '联系人电话'
            "
            prop="manage_mobile"
          >
            <div>
              <el-input
                v-model="addForm.manage_mobile"
                placeholder="请输入"
              ></el-input>
            </div>
          </el-form-item>
           <el-form-item label="绑卡类型" prop="account_type" v-if="addForm.certification_type==20">
            <el-radio-group
              v-model="addForm.account_type"
        
            >
              <el-radio :label="10">个人</el-radio>
 
              <el-radio :label="30">企业</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">关闭</el-button>
        <el-button type="primary" :loading="submitLoading" @click="qr"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {

  postGetIdcardInfo,

} from "@/api/general/manager.js";

export default {
  name: "editDialog",
  props: {},
  data() {
    return {
      token: sessionStorage.getItem("token"),
      httpurl: process.env.VUE_APP_GENERAL_URL + "/uploadBusinessLicense",
      dialogVisible: false,
      info: "",
      uploadLoading: false,
      submitLoading: false,
      addForm: {
        supplier_id: "", //	T文本	是	供应商id
        certification_type: "", //	T文本	是	认证类型
        license_img: "", //	T文本	是	营业执照图片
        license_info: "", //	T文本	否	营业执照ocr数据
        uscc: "", //	T文本	是	统一社会代码
        idcard_a: "", //	T文本	是	身份证国徽面图片
        idcard_b: "", //	T文本	是	身份证人像面图片
        idcard_name: "", //	T文本	是	法人姓名
        manage_mobile: "", //	T文本	是	法人手机号
        idcard_code: "", //	T文本	是	法人身份证号码
        company_mobile: "", //	T文本	是	企业联系电话
        account_type: "", //	T文本	是	绑卡类型
      },
      idcard_a: [], // 身份证国徽图片
      idcard_b: [], // 身份证人像图片
      license_img: [], // 变更协议
      // 表单校验
      cityRules: {
        certification_type: [
          {
            required: true,
            message: "请选择主体性质",
            trigger: ["blur", "change"],
          },
        ],
        uscc: [
          {
            required: true,
            message: "请输入社会统一信息码",
            trigger: ["blur", "change"],
          },
        ],
        company_mobile: [
          {
            required: true,
            message: "请输入企业联系电话",
            trigger: ["blur", "change"],
          },
        ],
        account_type: [
          {
            required: true,
            message: "请选择绑卡类型",
            trigger: ["blur", "change"],
          },
        ],

        bank_mobile: [
          {
            required: true,
            message: "请输入预留电话",
            trigger: ["blur", "change"],
          },
          // 正则判断为字母或数字
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],
        idcard_a: [
          {
            required: true,
            message: "请上传身份证国徽页图片",
            trigger: ["blur", "change"],
          },
        ],
        idcard_b: [
          {
            required: true,
            message: "请上传身份证人像页图片",
            trigger: ["blur", "change"],
          },
        ],
        manage_mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: ["blur", "change"],
          },
          // 正则判断为字母或数字
          {
            pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
            message: "该手机号码不符合规范",
            trigger: ["blur"],
          },
        ],

        idcard_name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: ["blur", "change"],
          },
        ],

        idcard_code: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"],
          },
        ],
        license_img: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    onsuccess(res) {
      console.log(res, "11111");
      if (res.msg) {
        this.$message({
          message: res.msg,
          type: "error",
        });
        return;
      }
      this.license_img = [{ url: res.data.file, uid: 1 }];
      this.addForm.uscc = res.data.license_info.reg_num;
      this.addForm.register_name = res.data.license_info.name;
      this.addForm.license_img = res.data.file;
      this.addForm.license_info = res.data.license_info;
    },
    /**
     * 删除图片
     */
    onHandleDeleteFile(name) {
      this[name] = [];
      this.addForm[name] = "";
      this.$refs.refCityForm.validateField(name);
    },
    /**
     * 上传图片
     */
    onHandleUploadFile(options, name) {
      this.uploadLoading = true;
      // 拿到 file
      let file = options.file;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        // console.log(e.target.result);
        this.ajaxUploadImage(e.target.result, name, options.file.uid);
      };
    },
    /**
     * 图片路径请求
     */
    async ajaxUploadImage(img, name, uid) {
      try {
        const res = await this.$api.general.uploadImage({ file_data: img });
        // 增加uid 赋值 解决上传图片跳动问题
        this[name] = [{ url: res.data, uid }];
       
            if (name == "idcard_b") {
          this.postAjaxGetIdcardInfo(res.data); // 人像页ocr 识别
        }
 this.addForm[name] = res.data;
        
        this.$refs.refCityForm.validateField(name);
      } catch (err) {
      } finally {
        this.uploadLoading = false;
      }
    },
        // 身份证人像页上传ocr 识别身份证号
    async postAjaxGetIdcardInfo(url) {
      try {
        const res = await postGetIdcardInfo({ image_url: url });
        this.addForm.idcard_code = res.data.idcard_code;
        this.addForm.idcard_name = res.data.idcard_name;
        console.log(res, res.data.idcard_code, this.addForm, "res==");
      } catch (error) {
        console.log(error, "postGetIdcardInfo");
      }
    },
    /**
     * 预览上传图片
     */
    onHandlePictureCardPreview(file) {
      const params = {
        bigImage: file.url,
        showImage: true,
      };
      this.$emit("on-show-image", params);
    },

    /**
     * 初始化
     */
    onInitData(data) {
      this.info = data;
    //    this.idcard_a= [] // 身份证国徽图片
    //   this.idcard_b=[] // 身份证人像图片
    //   this.license_img= [] // 变更协议
      this.dialogVisible = true;
      this.addForm={
        ...data,
        supplier_id:data.id,
        license_img:data.license?data.license.img:'',
        uscc:data.license?data.license.reg_num:'',
        license_info:data.license,
        manage_mobile:data.manage_mobile,
         account_type:data.supplier_bank?data.supplier_bank.account_type:'',
      }
      this.idcard_a=data.idcard_a?[{url:data.idcard_a}]:[]
      this.idcard_b=data.idcard_b?[{url:data.idcard_b}]:[]
      this.license_img=data.license?[{url:data.license.img}]:[]
    },
    qr() {
      console.log(this.addForm, "this.cityForm==");
      this.$refs.refCityForm.validate(async (valid) => {
        console.log(valid, "1valid11");
        if (!valid) {
          return;
        }
        let obj = JSON.parse(JSON.stringify(this.addForm));

        this.submitLoading = true;

        this.$api.general
          .supplierupdate({
            ...obj,
          })
          .then((res) => {
            this.$emit("on-change", true);
            this.onHandleClose();
            this.$message({
              type: "success",
              message: "确认成功!",
            });
            this.submitLoading = false;
          })
          .catch((err) => {
            this.submitLoading = false;
          });

        // try {
        //   const res = await certifylogistics(obj);
        //   console.log(res, "res==");

        //   this.dialogVisible = false;
        //   this.$message({
        //     message: "城市仓主体认证成功",
        //     type: "success",
        //   });
        //   this.$emit("on-refresh-list");
        // } catch (error) {
        //   console.log(error, "certifylogistics");
        // } finally {

        // }
      });
    },

    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.editDialog {
  .editDialog-cnt {
    height: 500px;
    overflow-y: auto;
    padding-right: 40px;
    box-sizing: border-box;
  }
  .list-item {
    display: flex;
    align-items: center;

    .list-item-left {
      font-size: 24px;
      color: #000;
    }
    .list-item-right {
      font-size: 24px;
      .el-image {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
